import { render } from "./DocumentsGeneral..vue?vue&type=template&id=9c64118e&scoped=true"
import script from "./DocumentsGeneral..vue?vue&type=script&lang=js"
export * from "./DocumentsGeneral..vue?vue&type=script&lang=js"

import "./DocumentsGeneral..vue?vue&type=style&index=0&id=9c64118e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c64118e"]])

export default __exports__